import { convertToLocalTimeUnix } from '@/composable/useFormatDateAndHours'
import { useLineChart } from '@/composables/useLineChart'

export interface TimeRange {
  min?: number
  max?: number
}

export interface ChartConfig {
  chartId: string
  timeRange: TimeRange
}

export function createDemandChartOptions(config: ChartConfig) {
  const { chartOptions } = useLineChart({
    chartId: config.chartId,
    exportConfig: {
      filename: 'dados-sensor',
      unit: 'kW',
    },
    yAxisFormatter: (value: number) => `${value?.toFixed(0)} kW`,
    tooltipYFormatter: (val: number) => `${val?.toFixed(2)} kW`,
    unit: 'kW',
  })

  const timeRange = {
    min: config.timeRange.min,
    max: config.timeRange.max,
  }

  return {
    ...chartOptions.value,
    xaxis: {
      ...chartOptions.value.xaxis,
      ...timeRange,
    },
  }
}

export function calculateTimeRange(startDate?: Date, endDate?: Date): TimeRange {
  return {
    min: startDate ? convertToLocalTimeUnix(startDate) : undefined,
    max: endDate ? convertToLocalTimeUnix(endDate) : undefined,
  }
}
